// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by InsightsQueryParser.

export default class InsightsQueryVisitor extends antlr4.tree.ParseTreeVisitor {

	// Visit a parse tree produced by InsightsQueryParser#rootExpression.
	visitRootExpression(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#AndExpr.
	visitAndExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#EqualExpr.
	visitEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#GreaterThanExpr.
	visitGreaterThanExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#MultiplyExpr.
	visitMultiplyExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#UnaryNotExpr.
	visitUnaryNotExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#AddExpr.
	visitAddExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#RaiseToExpr.
	visitRaiseToExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#NotEqualExpr.
	visitNotEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#OrExpr.
	visitOrExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#DivideExpr.
	visitDivideExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#LessThanOrEqualExpr.
	visitLessThanOrEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#ConcatExpr.
	visitConcatExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#FunctionCallExpr.
	visitFunctionCallExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#IdentifierExpr.
	visitIdentifierExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#UnaryPlusExpr.
	visitUnaryPlusExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#LiteralExpr.
	visitLiteralExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#ParenthesizedExpr.
	visitParenthesizedExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#SubtractExpr.
	visitSubtractExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#LessThanExpr.
	visitLessThanExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#UnaryMinusExpr.
	visitUnaryMinusExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#GreaterThanOrEqualExpr.
	visitGreaterThanOrEqualExpr(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#NumberLiteral.
	visitNumberLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#StringLiteral.
	visitStringLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#functionCall.
	visitFunctionCall(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#callArgs.
	visitCallArgs(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#values.
	visitValues(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by InsightsQueryParser#identifier.
	visitIdentifier(ctx) {
	  return this.visitChildren(ctx);
	}



}